import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { changelogRepository } from '@webapp/platform/discover-more/data-access/repositories/ChangelogRepository'

const base = ['discover-more', 'changelog']

export const changelogQueryConfig = {
  getLatestReleases: () => ({
    queryKey: buildQueryKey([...base, 'latest-releases']),
    queryFn: () => changelogRepository.getLatestReleases(),
  }),
}
